import { clsx, type ClassValue } from 'clsx'
import { format } from 'date-fns'
import { es } from 'date-fns/locale'
import { twMerge } from 'tailwind-merge'

export function cn(...inputs: ClassValue[]) {
	return twMerge(clsx(inputs))
}

export function formatDateForDisplay(dateString: string) {
	try {
		// Parse the date string consistently
		// If it's an ISO string (YYYY-MM-DDTHH:mm:ss), extract date and time parts
		const date = new Date(dateString)

		// Check if the date is valid
		if (isNaN(date.getTime())) {
			return dateString
		}

		// For consistency between server and client, always format the date
		// using the exact same timezone-independent approach
		// Extract components directly from the ISO string if possible
		if (dateString.includes('T')) {
			const [datePart, timePart] = dateString.split('T')
			const [year, month, day] = datePart.split('-')
			const [hours, minutes] = timePart.split(':')

			// Create a date object from the parts to ensure consistent formatting
			const consistentDate = new Date(
				parseInt(year),
				parseInt(month) - 1,
				parseInt(day),
				parseInt(hours),
				parseInt(minutes)
			)

			return format(consistentDate, "dd_MMM_yyyy - HH:mm 'hrs'", { locale: es })
				.replace(/ /g, '_')
				.replace(/_-_/g, ' - ')
		} else {
			// If no time component, just format the date
			return format(date, 'dd_MMM_yyyy', { locale: es }).replace(/ /g, '_')
		}
	} catch {
		return dateString
	}
}
export function formatDateForApi(date: Date): string {
	// Format: YYYY-MM-DDTHH:mm:ss (without milliseconds and Z)
	return date.toISOString().split('.')[0]
}
